import { MembershipType } from "sdk/types";
import { useCurrentUser } from "./useCurrentUser";

interface UseMembershipType {
  isPregnant: boolean;
  isPostpartum: boolean;
  isFertility: boolean;
  type: MembershipType | null;
}

export const useMembershipType = (): UseMembershipType => {
  const user = useCurrentUser();
  if (!user) {
    return {
      isPregnant: false,
      isPostpartum: false,
      isFertility: false,
      type: null,
    };
  }

  const {
    membership: { type },
  } = user!;

  return {
    isPregnant: type === "pregnancy",
    isPostpartum: type === "postpartum",
    isFertility: type === "fertility",
    type,
  };
};
